import React, { Component } from "react";
import { Modal, Form, Input, Row, Col, Radio } from "antd";
import { createCalendarNote, updateCalendarNote } from "../../services/calendarNote";

class CalendarNoteFormModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            disableOkButton: false,
        }
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.prepareForm = this.prepareForm.bind(this);
        this.formRef = React.createRef();
    }

    async onFormSubmit() {
        const { data, editing, setVisible, reloadData, reloadAfterCreate, selectedEmployee, selectedDateCell } = this.props;
        await this.setState({
            disableOkButton: true
        })
        let values;
        let passed = true;
        try {
            values = await this.formRef.current.validateFields()
        }
        catch (err) {
            values = err.values
            passed = false
        }

        if (passed) {
            try {
                if (!editing) {
                    values["employee"] = selectedEmployee
                    values["note_at"] = selectedDateCell.format("YYYY-MM-DD HH:mm:ss")
                    await createCalendarNote(values)
                    reloadAfterCreate();
                }
                else {
                    await updateCalendarNote(data['id'], values)
                    reloadData();
                }
                setVisible(false);

            }
            catch (err) {
            }
            finally {
                this.setState({
                    disableOkButton: false
                })
            }
        }
        else {
            this.setState({
                disableOkButton: false
            })
        }

    };

    componentDidMount() {
        this.props.onRef(this);
    }

    async prepareForm() {

    }

    render() {
        const { editing, visible, setVisible, data, selectedDateCell } = this.props;
        const { disableOkButton } = this.state;
        return (
            <Modal
                visible={visible}
                onCancel={() => { setVisible(false) }}
                onOk={this.onFormSubmit}
                title={editing ? "แก้ไขโน๊ตวันที่" : `โน๊ตลงวันที่ ${selectedDateCell ? selectedDateCell.format("DD/MM/YYYY") : "..."}`}
                okText={editing ? "แก้ไข" : "บันทึก"}
                cancelText={"ปิด"}
                keyboard={false}
                maskClosable={false}
                destroyOnClose={true}
                okButtonProps={{disabled: disableOkButton}}
            >
                <Form
                    ref={this.formRef}
                    layout={'vertical'}
                    initialValues={data}
                >
                    {/* <Row gutter={12}>
                        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                            <Form.Item
                                label="ประเภท"
                                name="type"
                                rules={[
                                    {
                                        required: true,
                                        message: "กรุณาเลือกเข้า/ออกงาน"
                                    }
                                ]}
                            >
                                <Radio.Group>
                                    {typeOptions.map(typ => <Radio key={typ.value} value={typ.value}>{typ.name}</Radio>)}
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row> */}
                    
                    <Row gutter={12}>
                        {/* <Col xs={24} sm={24} md={6} lg={6} xl={6} xxl={6}>
                        </Col> */}
                        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
                        <Form.Item
                                hasFeedback
                                label="เบิก"
                                name="withdraw"
                                rules={[
                                    { min: 0, message: 'จำนวนห้ามติดลบ' }
                                ]}>
                                <Input type="number" />
                            </Form.Item>
                        </Col>
                    </Row>
                    
                    <Row gutter={12}>
                        <Col span={24}>
                            <Form.Item
                                hasFeedback
                                label="รายละเอียด"
                                name="description"
                                rules={[]}>
                                <Input />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Modal>
        );
    }
}

export default CalendarNoteFormModal;